import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
export const ThemeToggle = () => {
    const [theme, setTheme] = useState(() => {
        if (typeof window === 'undefined') {
            return 'light';
        }
        return window.localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';
    });
    useEffect(() => {
        document.documentElement.classList.toggle('dark', theme === 'dark');
        window.localStorage.setItem('theme', theme);
    }, [theme]);
    return (_jsx("button", { type: "button", onClick: () => setTheme((current) => (current === 'dark' ? 'light' : 'dark')), className: "soft-chip interactive-card rounded-full px-4 py-2.5 text-sm font-semibold text-[color:var(--text)]", children: theme === 'dark' ? 'Light mode' : 'Dark mode' }));
};
